import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { GlobalConstants } from "../common/global-constants";
import { BOClinicHistory } from "../models/BOClinicHistory.model";
import { BOFilter } from "../models/BOFilter";
import { BODateRangeFilter } from "../models/BODateRangeFilter.model";
import { IDataClinicHistoryAgrouped } from "../interfaces/Igeneral.interface";

@Injectable()
export class ClinicHistoryService{
    myAppUrl = GlobalConstants.apiURL;
    myApiUrl = 'api/ClinicHistory/';

    constructor(private http:HttpClient){}

    createClinicHistory(patientId:number, area:number):Observable<number>
    {
          return this.http.get<number>(this.myAppUrl + this.myApiUrl + 'createClinicHistory/' + patientId+'/'+area);
    }

    updateClinicHistory(clinicHistory:BOClinicHistory, step:string):Observable<number>{

        const httpOptions = {
            headers: new HttpHeaders({'Content-Type': 'application/json'})
          }
          const body=JSON.stringify(clinicHistory);
        //Ric
        return this.http.post<number>(this.myAppUrl + this.myApiUrl + 'updateClinicHistory/'+step,body,httpOptions);
        //end Ric
        //  return this.http.post<number>(this.myAppUrl + this.myApiUrl + 'updateClinicHistory',body,httpOptions);

    }

    incrementControlConsultation(clinicHistoryId: number): Observable<number> {
        return this.http.post<number>(
            this.myAppUrl + this.myApiUrl + 'incrementControlConsultation/' + clinicHistoryId,
            null
        );
    }


    //Ric

    updateClinicHistoryHealthTechnologies(clinicHistory:BOClinicHistory):Observable<number>{
        const httpOptions = {
            headers: new HttpHeaders({'Content-Type': 'application/json'})
          }
          const body=JSON.stringify(clinicHistory);
        return this.http.post<number>(this.myAppUrl + this.myApiUrl + 'updateClinicHistoryHealthTechnologies',body,httpOptions);
    }

    updateClinicHistoryHealthTechnologiesResult(clinicHistory:BOClinicHistory):Observable<number>{
        const httpOptions = {
            headers: new HttpHeaders({'Content-Type': 'application/json'})
          }
          const body=JSON.stringify(clinicHistory);
        return this.http.post<number>(this.myAppUrl + this.myApiUrl + 'updateClinicHistoryHealthTechnologiesResult',body,httpOptions);
    }

    getClinicHistories(filter:BOFilter, areaId:number):Observable<BOClinicHistory[]>
    {
      const httpOptions = {
          headers: new HttpHeaders({'Content-Type': 'application/json'})
        }
        const body=JSON.stringify(filter);
      return this.http.post<BOClinicHistory[]>(this.myAppUrl + this.myApiUrl + 'getAll/'+areaId,body,httpOptions);
    }    //Ric end



    getClinicHistoriesByPatient(patientId:number, area:number=3):Observable<BOClinicHistory[]>{
    return this.http.get<BOClinicHistory[]>(this.myAppUrl + this.myApiUrl + 'getAllByPatient/' + patientId + '/' + area);
    }

    getClinicHistory(clinicHistoryId:number):Observable<BOClinicHistory>{
        return this.http.get<BOClinicHistory>(this.myAppUrl + this.myApiUrl + 'getClinicHistory/' + clinicHistoryId);
    }

getClinicalHistoriesByAllAndDates(datesFilter:BODateRangeFilter,  areaId:number):Observable<Array<Array<BOClinicHistory>>>{
  const httpOptions = {
    headers: new HttpHeaders({'Content-Type': 'application/json'})
  }
  const body= JSON.stringify(datesFilter);
  return this.http.post<Array<Array<BOClinicHistory>>>(this.myAppUrl + this.myApiUrl + 'getClinicalHistoriesByAllAndDates/'+areaId,body,httpOptions);
}

getDataForXubioAsync(datesFilter:BODateRangeFilter):Observable<BOClinicHistory[]>{
  const httpOptions = {
    headers: new HttpHeaders({'Content-Type': 'application/json'})
  }
  const body= JSON.stringify(datesFilter);
  return this.http.post<BOClinicHistory[]>(this.myAppUrl + this.myApiUrl + 'getDataForXubioAsync',body,httpOptions);
}

getCHWithPatientByDatesAndArea(datesFilter:BODateRangeFilter,  areaId:number):Observable<BOClinicHistory[]>{
  const httpOptions = {
    headers: new HttpHeaders({'Content-Type': 'application/json'})
  }
  const body= JSON.stringify(datesFilter);
  return this.http.post<BOClinicHistory[]>(this.myAppUrl + this.myApiUrl + 'getCHWithPatientByDatesAndArea/'+areaId,body,httpOptions);
}


getClinicHistoriesByAreaAndDates(datesFilter:BODateRangeFilter, patientId, areaId:number, patientI):Observable<Array<Array<BOClinicHistory>>>{
  const httpOptions = {
    headers: new HttpHeaders({'Content-Type': 'application/json'})
  }
  const body= JSON.stringify(datesFilter);
  return this.http.post<Array<Array<BOClinicHistory>>>(this.myAppUrl + this.myApiUrl + 'getAllByPatientAreaAndDates/'+patientId + '/' +areaId,body,httpOptions);
}

//
  getClinicHistoriesByProfessionalAndDates(datesFilter:BODateRangeFilter, professionalId:number):Observable<Array<Array<IDataClinicHistoryAgrouped>>>{
    const httpOptions = {
      headers: new HttpHeaders({'Content-Type': 'application/json'})
    }
    const body= JSON.stringify(datesFilter);

    return this.http.post<Array<Array<IDataClinicHistoryAgrouped>>>(this.myAppUrl + this.myApiUrl + 'getClinicHistoriesByProfessionalAndDates/'+professionalId,body,httpOptions);
  }

  getClinicHistoriesByServicesAndDates(datesFilter:BODateRangeFilter, areaId:number):Observable<BOClinicHistory[][]>{
    const httpOptions = {
      headers: new HttpHeaders({'Content-Type': 'application/json'})
    }
    const body= JSON.stringify(datesFilter);

    return this.http.post<BOClinicHistory[][]>(this.myAppUrl + this.myApiUrl + 'getClinicHistoriesByServicesAndDates/'+areaId,body,httpOptions);
  }

  //#region Today

  getClinicHistoriesAllToday():Observable<Array<Array<BOClinicHistory>>>{

    return this.http.get<Array<Array<BOClinicHistory>>>(this.myAppUrl + this.myApiUrl + 'getClinicHistoriesAllToday/', {responseType: 'json'});

  }

  getClinicHistoriesByProfesionaToday(profesionalId:number):Observable<Array<Array<IDataClinicHistoryAgrouped>>>{

    return this.http.get<Array<Array<IDataClinicHistoryAgrouped>>>(this.myAppUrl + this.myApiUrl + 'getClinicHistoriesByProfesionalToday/' + profesionalId, {responseType: 'json'});
  }

  getClinicHistoriesByServicesToday():Observable<Array<Array<BOClinicHistory>>>{

    return this.http.post<Array<Array<BOClinicHistory>>>(this.myAppUrl + this.myApiUrl + 'getClinicHistoriesByServicesToday',{responseType: 'json'});
  }
//#endregion Today

}
